import http2 from "@/components/services/http-common2"
import http from "@/components/services/http-common"

const TOKEN_URL = ""
const GET_PHIEU_URL = ""
const SET_TINHTRANG_URL = ""
const GET_HANG_HOA_URL = ""
const GET_HANG_HOA_UNIT_URL = ""
var TOKEN = ""
// LOGS
const GET_LOG_URL = "SyncElearning/logs"
const SYNC_CREATE_URL = "SyncElearning/create-employee"

export default class Api {
    //modified
    syncCreate = (employeeCode) => {
        return http.get(SYNC_CREATE_URL, {
            params: {
                employeeCode: employeeCode
            }
        })
    }


    //template
    fetchData = () => http.get(GET_LOG_URL).then(r =>r.data)
    
    getToken = (user_id) => http2.get(`${TOKEN_URL}`, {
        params: {
            user_id: user_id
        }
    }).then(r => {
        TOKEN = r.data.token
        return r.data
    })

    getPhieu = (token, user_id, fromDate = '2023-06-01', toDate='2100-01-01') => {
        const token2 = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiIsInByaUtleSI6ImFjZjAxMzQxMDE5MjE1OGJhODBlZGY0MmEyMjIxZTRmIn0.eyJ1c2VyX2lkIjoiTlMyOTc3IiwiZXhwaXJlcyI6MTY4NzA3ODIwMC44Njc5NzU3fQ.VI-8IKg6Cj1BTC_TS2Bv8wFd84ob6s3POQDP0v90Ftw"
        if(!user_id) return false
        return http2.get(`${GET_PHIEU_URL}`, {
            params: {
                user_id: user_id,
                tungay: fromDate,
                denngay: toDate,
            },
            
            headers: {
                'Authorization': `Bearer ${TOKEN}`
            }
        }).then(r => r.data)
    }

    setTinhTrangNote = (ID, user_capnhat, note, mode) => {
        if(mode == "ACCEPT")
            return http2.post(SET_TINHTRANG_URL, {
                "ID": ID,
                "dat_duoc": note,
                "user_capnhat": user_capnhat
            }, {
                headers: {
                    'Authorization': `Bearer ${TOKEN}`
                }
            })
        if(mode == "DENY") 
            return http2.post(SET_TINHTRANG_URL, {
                "ID": ID,
                "khong_datduoc": note,
                "user_capnhat": user_capnhat
            }, {
                headers: {
                    'Authorization': `Bearer ${TOKEN}`
                }
            })
    }

    setTinhTrang = (ID, user_xacnhan, tinh_trang) => {
        return http2.post(SET_TINHTRANG_URL, {
            ID: ID,
            user_xacnhan: user_xacnhan,
            tinh_trang: tinh_trang
        }, {
            headers: {
                'Authorization': `Bearer ${TOKEN}`
            }
        })
    }

    getHangHoa = (danhmuc="No_", giatri="") => {
        return http2.get(GET_HANG_HOA_URL, {
            params: {
                danhmuc: danhmuc,
                giatri:giatri
            }
        }, {
            headers: {
                'Authorization': `Bearer ${TOKEN}`
            }
        })
    }
    
    getHangHoaUnit = (mahanghoa, user_id) => {
        return http2.get(GET_HANG_HOA_UNIT_URL, {
            params: {
                mahanghoa: mahanghoa,
                user_id:user_id
            }
        }, {
            headers: {
                'Authorization': `Bearer ${TOKEN}`
            }
        })
    }
}
